
import { defineComponent } from 'vue';
import { AppFormRow, AppInput, AppCard, AppSelect, AppButton } from '@/components';
import { AppFileUpload, AppImageHolder, AppSimpleTable, AppDateTimePicker } from '@/components';
import { usePromotionItemAdd } from '@/modules/promotion/item/model/add';
import { Options, DisplayType } from '@/modules/promotion/item/model/mixins';
import { ROUTE_NAME_PROMOTION } from '@/modules/promotion/router';

export default defineComponent({
    name: ROUTE_NAME_PROMOTION.ITEM.ADD,
    components: {
        AppFormRow,
        AppInput,
        AppCard,
        AppFileUpload,
        AppImageHolder,
        AppSelect,
        AppSimpleTable,
        AppButton,
        AppDateTimePicker
    },
    setup() {
        const { model, v$, actions, appSelectOptions } = usePromotionItemAdd();

        return { v$, model, actions, appSelectOptions, Options, DisplayType };
    }
});
